module.exports = __webpack_public_path__ + "static/img/top.6123e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/exam/images/top.png
// module id = i1no
// module chunks = 7